// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormHelperText from "@material-ui/core/FormHelperText";

import {
  REMOVE_CAMPSITE_IMAGE,
  SET_CAMPSITE_FILES_IMAGES,
  REMOVE_CAMPSITEMAP_IMAGE,
  SET_CAMPSITEMAP_FILES_IMAGES,
  SET_CAMPSITE_NAME,
  SET_CAMPSITE_NAME_ERROR,
  SET_CAMPSITE_REGISTER_KEY,
  ADD_CAMPSITE_CHANNEL,
  DELETE_CAMPSITE_CHANNEL,
  ADD_CAMPSITE_CITY,
  DELETE_CAMPSITE_CITY
} from "actions/types";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import CustomInput from "components/CustomInput/CustomInput";
import ImageUpload from "components/CustomUpload/ImageUpload";
// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

const ReactTags = require("react-tag-autocomplete");

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  },
  tags: {
    margin: "20px",
    width: "100%"
  },
  ...customInputStyle,
  ...customSelectStyle
};

class Step1 extends React.Component {
  sendState() {
    return this.state;
  }

  isValidated() {
    const { dispatch, name } = this.props;

    let success = true;
    if (!name || name.trim().length === 0) {
      dispatch({
        type: SET_CAMPSITE_NAME_ERROR
      });
      success = false;
    }
    return success;
  }

  onImageLoaded = (name, imagePreviewUrl) => {
    const { dispatch } = this.props;
    dispatch({
      type: SET_CAMPSITE_FILES_IMAGES,
      payload: [{ name, base64: imagePreviewUrl, out: "logoUri" }]
    });
  };

  onImageRemoved = () => {
    this.props.dispatch({
      type: REMOVE_CAMPSITE_IMAGE
    });
  };

  onCampsiteMapLoaded = (name, imagePreviewUrl) => {
    const { dispatch } = this.props;
    dispatch({
      type: SET_CAMPSITEMAP_FILES_IMAGES,
      payload: [
        {
          name,
          base64: imagePreviewUrl,
          ignoreQualityTransform: true,
          out: "mapUri"
        },
        { name: name + "-small", base64: imagePreviewUrl, out: "mapSmallUri" }
      ]
    });
  };

  onCampsiteMapRemoved = () => {
    this.props.dispatch({
      type: REMOVE_CAMPSITEMAP_IMAGE
    });
  };

  handleDeleteCity = index => {
    const { dispatch } = this.props;

    dispatch({
      type: DELETE_CAMPSITE_CITY,
      value: index
    });
  };

  handleAdditionCity = city => {
    const { dispatch } = this.props;
    dispatch({
      type: ADD_CAMPSITE_CITY,
      value: city
    });
  };

  handleDelete = index => {
    const { dispatch } = this.props;

    dispatch({
      type: DELETE_CAMPSITE_CHANNEL,
      value: index
    });
  };

  handleAddition = channel => {
    const { dispatch } = this.props;
    dispatch({
      type: ADD_CAMPSITE_CHANNEL,
      value: channel
    });
  };

  render() {
    const {
      dispatch,
      classes,
      name,
      nameErrorMsg,
      logoUri,
      mapSmallUri,
      registerkey,
      channels,
      channelsSuggestions,
      citiesTags,
      citiesSuggestions
    } = this.props;
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={4} md={4}>
          <legend>Logo</legend>
          <ImageUpload
            ref={this.child}
            onImageLoaded={this.onImageLoaded}
            onImageRemoved={this.onImageRemoved}
            photoUri={logoUri}
            addButtonProps={{
              color: "brown",
              round: true
            }}
            changeButtonProps={{
              color: "brown",
              round: true
            }}
            removeButtonProps={{
              color: "danger",
              round: true
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={4} md={4}>
          <legend>Plan intéractif</legend>
          <ImageUpload
            ref={this.child}
            onImageLoaded={this.onCampsiteMapLoaded}
            onImageRemoved={this.onCampsiteMapRemoved}
            photoUri={mapSmallUri}
            addButtonProps={{
              color: "brown",
              round: true
            }}
            changeButtonProps={{
              color: "brown",
              round: true
            }}
            removeButtonProps={{
              color: "danger",
              round: true
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Nom *"
            id="name"
            formControlProps={{
              fullWidth: true
            }}
            error={nameErrorMsg !== null}
            helperText={nameErrorMsg}
            inputProps={{
              value: name ? name : "",
              onChange: e =>
                dispatch({
                  type: SET_CAMPSITE_NAME,
                  value: e.target.value
                })
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Clé du camping pour rejoindre la communauté"
            id="registerkey"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value: registerkey ? registerkey : "",
              onChange: e =>
                dispatch({
                  type: SET_CAMPSITE_REGISTER_KEY,
                  value: e.target.value
                })
            }}
          />
        </GridItem>
        <div className={classes.tags}>
          <FormHelperText>{"Villes rattachées au camping"}</FormHelperText>
          <ReactTags
            placeholderText="Ville(s) ..."
            tags={citiesTags}
            suggestions={citiesSuggestions}
            onDelete={this.handleDeleteCity}
            onAddition={this.handleAdditionCity}
            removeButtonText="Cliquez pour retirer"
          />
        </div>
        <div className={classes.tags}>
          <FormHelperText>
            {
              "Canaux de diffusion depuis lesquelles recevoir les publications et bons plans"
            }
          </FormHelperText>
          <ReactTags
            placeholderText="Canaux de diffusion ..."
            tags={channels}
            suggestions={channelsSuggestions}
            onDelete={this.handleDelete}
            onAddition={this.handleAddition}
            removeButtonText="Cliquez pour retirer"
          />
        </div>
      </GridContainer>
    );
  }
}

Step1.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = state => {
  const {
    name,
    nameErrorMsg,
    logoUri,
    mapSmallUri,
    registerkey,
    channels,
    channelsSuggestions,
    citiesTags,
    citiesSuggestions
  } = state.campsiteReducer;
  return {
    name,
    nameErrorMsg,
    logoUri,
    mapSmallUri,
    registerkey,
    channels,
    channelsSuggestions,
    citiesTags,
    citiesSuggestions
  };
};

export default connect(mapStateToProps)(withStyles(style)(Step1));
